import React from 'react';
import { useLanguage } from '../../../i18n/LanguageContext';

import { motion } from 'framer-motion';

const AstrologyHeader = () => {
  const { t } = useLanguage();

  return (
    <section className="py-12 mt-20 bg-gradient-to-r from-orange-500 to-red-500 text-white relative overflow-hidden">
      <div className="absolute inset-0 bg-black bg-opacity-20"></div>
      <div className="container mx-auto px-4 text-center relative z-10">
        <motion.h1 
          className="text-3xl md:text-5xl font-bold mb-3"
          initial={{ opacity: 0, y: -50 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, ease: "easeOut" }}
        >
          🔮 {t('vedicAstrology')}
        </motion.h1>
        <motion.p 
          className="text-lg md:text-xl text-orange-100 max-w-3xl mx-auto"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.8, delay: 0.3, ease: "easeOut" }}
        >
          {t('discoverCosmicBlueprint')}
        </motion.p>
      </div>
    </section>
  );
};

export default AstrologyHeader;
